import axios from '../../api/axiosInstance';
import { STATUS, extractErrorInfo } from './sharedfunction';

const BASE = `${process.env.REACT_APP_API_URL || ''}/plan`;

/**
 * Get all plans with org count per plan.
 * @returns {Promise<{ status: number, data?: Array, message?: string } | { status: number, error?: string }>}
 */
export async function getPlans() {
  try {
    const response = await axios.get(BASE, { withCredentials: true });
    if (response?.data?.success) {
      const data = response?.data?.data;
      return {
        status: STATUS.SUCCESS,
        data: Array.isArray(data) ? data : [],
        message: response?.data?.message,
      };
    }
    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
    };
  } catch (error) {
    return extractErrorInfo(error);
  }
}

/**
 * Create a new plan.
 * @param {Object} body
 * @param {string} body.name - Plan name
 * @param {number} body.credit_limit - Non-negative integer
 * @returns {Promise<{ status: number, data?: object, message?: string } | { status: number, error?: string }>}
 */
export async function createPlan(body) {
  try {
    const response = await axios.post(BASE, body, {
      withCredentials: true,
    });
    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data,
        message: response?.data?.message,
      };
    }
    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
    };
  } catch (error) {
    return extractErrorInfo(error);
  }
}
